<div class="modal-container">
  <div [ngClass]="'modal-' + modalType">
    <!-- header for snappay -->
    <div class="modal-header" *ngIf="modalType === 'snappay'">
      <span>{{ 'modal.selectCardTitle' | cxTranslate }}</span>
      <span (click)="closeModal('Cross click')" class="modal-header-close">{{ 'modal.close' | cxTranslate }}</span>
    </div>
    <!-- iframe div-->
    <div #iframeContainer class="modal-content">
      <div *ngIf="isLoading" class="form-spinner">
        <mat-spinner [diameter]="25"></mat-spinner>
      </div>
    </div>
  </div>
</div>
